import React, { useMemo } from 'react';
import { Chart } from 'react-google-charts';

import PropTypes from 'prop-types';

import { Mui } from 'components';

function GoogleChart({ options, ...other }) {
  // Hooks
  const theme = Mui.useTheme();

  // Constants
  const chartOptions = useMemo(
    () => ({ fontName: theme.typography.fontFamily, ...options }),
    [options, theme.typography.fontFamily],
  );

  return <Chart options={chartOptions} {...other} />;
}

GoogleChart.propTypes = {
  options: PropTypes.object,
};

export default GoogleChart;
